/* eslint-disable react-refresh/only-export-components */
import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './App';
import { GameContext } from './state/GameContext';
import { useGame } from './state/useGame';
import './styles/global.css';

function Root() {
  const game = useGame();
  return (
    <GameContext.Provider value={game}>
      <App />
    </GameContext.Provider>
  );
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <Root />
  </React.StrictMode>,
);
